import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { BaseService } from 'src/app/core/base/base.service';
import { RestService } from 'src/app/core/service/rest.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PatientsByDoctorService extends BaseService {

  constructor(
    protected store: Store<any>,
    protected rest: RestService
  ) {
    super();
  }

  getPatientsByDoctor = (reportDate: Date): Observable<any[]> =>
    this.rest.get<any[]>({ url: `${environment.endpoints.report}/patients-by-doctor`, params: { reportDate } })

}
